import { combineReducers } from 'redux';

import filters from './filters';

/**
 * @typedef {{
 *  filters: import('./filters').State,
 * }} SelfServiceDetailsUIReducer
 */
export default combineReducers({
  filters,
});
